
<!-- <mat-tab-group>
    <mat-tab label="First Tab">
      <ng-template mat-tab-label>
        First Tab
      </ng-template>
      <p>Content for the first tab goes here...</p>
    </mat-tab>
    <mat-tab label="Second Tab">
      <ng-template mat-tab-label>
        Second Tab
      </ng-template>
      <p>Content for the second tab goes here...</p>
    </mat-tab>
  </mat-tab-group> -->




<!--=============== Banner start ==================-->
<div id="main-wrapper" style="text-align: left">
  <div class="site-wrapper-reveal">
    <div class="position-relative w-100">
      <div class="d-flex align-items-left w-100 test">

        <!-- "> md" -->
        <img src="../../../assets/images/aiimages/bannerimage.png"
          class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="bannerimage" />

        <!-- "<= md" -->
        <img src="../../../assets/images/banners/artificialmobile.jpg" class="img img-responsive d-block d-md-none"
          width="100%" alt="" />

        <div class="position-absolute w-100 home-banner">
          <div class="row h-100 w-100">
            <div class="col-8 col-md-4 col-sm-6 banner-section" style="margin-top:5%">
              <div
                class="align-items-center banner-content-title  global_title global_banner_title  title_banner_content" role="heading">

                <span>Artificial Intelligence & Machine Learning </span>

              </div>
              <div class="global_sub_title global_banner_subtitle mt-3">

                <span>Commit to new vectors of growth and support long-term digital transforamtion with Maganti IT AI/ML
                  services.</span>

              </div>


              <div class="col pt-lg-3 pt-3 mt-lg-3">
                <a href="contact" class="global_button   text-left col text-white white_button">
                  <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="" /></div>
                  LET'S TALK
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->
<!--==================== Banner end ===================-->




<div class="brand-logo-slider-area section-space--ptb_60">

  <h6 class="test mb-4 px-2">Trusted by Global Technology Companies</h6>
  <div class="container-fluid">
      <div class="row">
          <div class="col-lg-12">
              <div class="brand-logo-slider__container-area">
                  <swiper-container class=" brand-logo-slider__container" slides-per-view="6" autoplay="true" loop="true" [breakpoints]="EmpswiperBreakpoints" > 
                      <swiper-slide class=" brand-logo brand-logo--slider">
                          <div class="swiper-wrapper brand-logo-slider__one">
                          <div class="brand-logo__image">
                              <img src="../../../assets/images/homepage/section_logos/futek.png" class="img-fluid"
                                  alt="section futek ">
                          </div></div>
                      </swiper-slide>
                      <swiper-slide class=" brand-logo brand-logo--slider">
                          <div class="swiper-wrapper brand-logo-slider__one">
                          <div class="brand-logo__image">
                              <img src="../../../assets/images/homepage/section_logos/apsvc-logo.png"
                                  class="img-fluid" alt="apsvclogo">
                          </div></div>
                      </swiper-slide>
                      <swiper-slide class=" brand-logo brand-logo--slider">
                          <div class="brand-logo__image">
                              <img src="../../../assets/images/homepage/section_logos/ouropinions-logo.png"
                                  class="img-fluid" alt="ouropinionslogo">
                          </div>
                      </swiper-slide>
                      <swiper-slide class=" brand-logo brand-logo--slider">
                          <div class="brand-logo__image">
                              <img src="../../../assets/images/homepage/section_logos/sarvani-logo.png"
                                  class="img-fluid" alt="swarvanilogo">
                          </div>
                      </swiper-slide>
                      <swiper-slide class=" brand-logo brand-logo--slider">
                          <div class="brand-logo__image">
                              <img src="../../../assets/images/homepage/section_logos/curoRC-logo.png"
                                  class="img-fluid" alt="curorclogo">
                          </div>
                      </swiper-slide>
                      <swiper-slide class=" brand-logo brand-logo--slider">
                          <div class="brand-logo__image">
                              <img src="../../../assets/images/homepage/section_logos/newliscr-image.png"
                                  class="img-fluid" alt="liscrlogo">
                          </div>
                      </swiper-slide>
                      <swiper-slide class="brand-logo brand-logo--slider">
                          <div class="brand-logo__image">
                              <img src="../../../assets/images/homepage/section_logos/laqshya-logo.png"
                                  class="img-fluid" alt="laqshaylogo">
                          </div>
                      </swiper-slide>
                      <swiper-slide class="brand-logo brand-logo--slider">
                          <div class="brand-logo__image">
                              <img src="../../../assets/images/homepage/section_logos/new-movie-logo.png"
                                  class="img-fluid" alt="movemeasurelogo">
                          </div>
                      </swiper-slide>
                      <swiper-slide class="brand-logo brand-logo--slider">
                          <div class="brand-logo__image">
                              <img src="../../../assets/images/homepage/section_logos/k3ssportslogo.png"
                                  class="img-fluid" alt="k3sportslogo">
                          </div>
                      </swiper-slide>

                  </swiper-container>
                  
              </div>
          </div>
      </div>
  </div>
</div>
<!-- =============== Trusted carousal section ends ================== -->





<!-- =============== Scale Your Businees section starts ================== -->
<div class="business">
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <h1 class="Impact_Al">Scale Your Businees Impact with AI</h1>
        <p role="contentinfo">
          Data and analytics aren't new. But the level at which they empower customers, markets,
          and business outcomes has taken a pragmatic shift. AI/ML has now become a transformative force
          empowering businesses to address business issues via intelligent automation, engagement, and decision-making.
        </p>
        <br>
        <p>We're a premier AI/ML service provider who partner with organizations
          to solve business challenges with cutting-edge Artificial Intelligence services that improve speed, enhance
          precision,
          and optimize customer experiences. Let's drive innovation together.
          <!-- Overall, this section would provide readers with a clear understanding of 
            the ways in which AI is being used to revolutionize the content creation process.
            </p> -->
      </div>

      <div class="col-md-6 col-sm-12">
        <img src="../../../assets/images/aiimages/scaleyourbusinessimg.png" class="img img-responsive" alt="scaleyourbusinessimg"
          style="width:70%" />
      </div>
    </div>
  </div>
</div>
<!-- =============== Scale Your Businees section ends ================== -->




<!-- ===================== capabilities section starts ================ -->
<div id="main-wrapper">
  <div class="site-wrapper-reveal">
    <div class="projects-wrapper section-space--ptb_90 projects-masonary-wrapper">
      <div class="container">
        <div class="row">
          <!-- <div class="container"> -->
          <div class="col-lg-12">
            <div class="section-title-wrap text-center section-space--mb_40">
              <div class="Capabilities">
                <div class="h4 fw-bold">Capabilities</div>
                <p>Invest in our Competitive advantage and win in your Business.<br>Explore some of our best
                  Offerings.</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 cat--2 filter machine_learning Technology">
            <div href="#" class="projects-wrap style-01">
              <div class="projects-image-box">
                <div class="image">
                  <img src="../../../assets/images/aiimages/naturalimage.png" alt="naturalimage" style="width:100%" class="w-33.3" />
                </div>
                <div class="NLP">
                  <h3> Natural Language Processing - NLP </h3>
                  <p> Enables Enterprise search for knowledge generation based on Text Analytics, Sentiment and
                    Information Analysis Services.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 cat--2 col-sm-12 filter machine_learning Technology">
            <div href="#" class="projects-wrap style-01">
              <div class="projects-image-box">
                <div class="projects-image">
                  <img src="../../../assets/images/aiimages/bannerimgforAIML.png" alt="bannerimgforAIML" style="width:100%; height: 100%"
                    class="w-33.3" />
                </div>
                <div class="Machinelearning">
                  <h3> Machine Learning </h3>
                  <p> Advanced algorithms to help organisations solve their key business challenges, enabling
                    data-driven decision-making and creating innovative business models.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 cat--2 col-sm-12 filter machine_learning Technology">
            <div href="#" class="projects-wrap style-01">
              <div class="projects-image-box">
                <div class="projects-image">
                  <img src="../../../assets/images/aiimages/cognitiveimg.png" alt="cognitiveimg" style="width:100%" class="w-33.3" />
                </div>
                <div class="Customeranalytics">
                  <h3> Cognitive Customer Analytics </h3>
                  <p>Provide Insights that augment decision -making and customer engagement enhancing business growth.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div id="main-wrapper">
  <div class="site-wrapper-reveal">
    <div class="projects-wrapper section-space--ptb_90 projects-masonary-wrapper"><s></s>
      <div class="container capabilitiescontainer">
        <div class="row">
          <!-- <div class="capabilitiescontainer"> -->
          <div class="col-lg-4 col-md-6 cat--2 filter machine_learning Technology">
            <div href="#" class="projects-wrap style-01">
              <div class="projects-image-box">
                <div class="projects-image">
                  <img src="../../../assets/images/aiimages/computervision.png" alt="computervision" style="width:100%" class="w-33.3" />
                </div>
                <div class="Computervision">
                  <h3> Computer Vision </h3>
                  <p> Improve Business performance with computer vision solutions for text, image and video.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 cat--2 filter machine_learning Technology">
            <div href="#" class="projects-wrap style-01">
              <div class="projects-image-box">
                <div class="projects-image">
                  <img src="../../../assets/images/aiimages/predictiveanalytics.png" alt="predictiveanalytics" style="width:100%; height: 100%"
                    class="w-33.3" />
                </div>
                <div class="Predictiveanalytics">
                  <h3> Predictive Analytics </h3>
                  <p> Empowering organizations adopt to the needs of the industry and innovative on the go with
                    data-driven insights.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 cat--2 filter machine_learning Technology">
            <div href="#" class="projects-wrap style-01">
              <div class="projects-image-box">
                <div class="projects-image">
                  <img src="../../../assets/images/aiimages/strategy&consulting.png" style="width:100%" alt="strategy&consulting"
                    class="w-33.3" />
                </div>
                <div class="strategy">
                  <h3> AI/ML strategy & Consulting </h3>
                  <p> Get expert guidance to harness the power of AI/ML to driven innovation, optimize processes, and
                    gain a Competitive edge.</p>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
<!-- =================== capabilities section ends ================== -->




<!-- =====================Expertise section starts =============== -->
<div class="expertisesection">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4">
        <img class="img-fluid"
          src="../../../assets/images/homepage/Independent-Perspective.png"
          alt="Independent-Perspectivesss">
        <h2 style="color: white">Expertise</h2>
        <p>Gain access to Global expertise to future resady AI/ML solutions.</p>
      </div>
      <div class="col-md-4">
        <img class="img-fluid"
          src="../../../assets/images/homepage/Business-Focus.png" alt="Business-Focus">
        <h2>Future Ready Solutions</h2>
        <p>Built a modern foundation with a data fabric blueprint leveraging automated tools and workflows.</p>
      </div>
      <div class="col-md-4">
        <img class="img-fluid"
          src="../../../assets/images/homepage/Custom-Delivery.png" alt="Custom-Delivery">
        <h2>Simplified Data Operations </h2>
        <p>Reduce the Complexity of your data estate with a full-fledged strategy that meet your bottom-line goals.</p>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->

<!-- =====================Expertise section ends =============== -->


<br><br>

<!-- =================== Use cases section starts =================== -->
<div id="main-wrapper">
  <div class="site-wrapper-reveal">
    <div class="usecasessection">
      <div class="container">
        <div class="row">
          <!-- <div class="container"> -->
          <div class="col-lg-12" style="margin-top:-17%">
            <div class="Usecases">
              <div class="h4 fw-bold">Use cases</div>
              <p style="color:black">Explore the diverse spectrum of <br> specialized used cases offered by Maganti IT.
              </p>
            </div>
          </div>
          <div class="container">
            <div class="usecases-first-blog">
              <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12 cat--2 filter machine_learning Technology">
                  <div href="#" class=" projects-wrap style-01 fading-image">
                    <div class=" projects-image-box contents">
                      <div class="projects-image">
                        <img src="../../../assets/images/aiimages/personalisationinsales&marketing.png" alt="personalisationinsales&marketing"
                          style="width:100%" class="w-33.3" />
                      </div>
                      <div class="content">
                        <h2 class="heading"> Personalisation in sales and marketing </h2>
                        <p style="margin-top:4%"> Tailor your interactions, content to customers based on their preferences, behavior, and
                          historical data and catapult towards success.</p>
                      </div>
                      <div class="content-details fadeIn-bottom">
                        <ul>
                          <li><i class="fa fa-check" role="presentation"></i> Product recommendations </li>
                          <li><i class="fa fa-check" role="presentation"></i> Email marketing </li>
                          <li><i class="fa fa-check" role="presentation"></i> Dynamic Pricing</li>
                          <li><i class="fa fa-check" role="presentation"></i> Advertisement Targeting </li>
                          <li><i class="fa fa-check" role="presentation"></i> Content Personalization </li>
                          <li><i class="fa fa-check" role="presentation"></i> Customer support chatbots</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 cat--2 filter machine_learning Technology"
                  style="line-height:2">
                  <div href="#" class="projects-wrap style-01 fading-image">
                    <div class="projects-image-box contents">
                      <div class="projects-image">
                        <img src="../../../assets/images/aiimages/speechrecognition.png" alt="speechrecognition" style="width:100%"
                          class="w-33.3" />
                      </div>
                      <div class="content">
                        <h2 class="heading"> Speech Recognition </h2>
                        <p style="line-height:24px;margin-top:4%"> Use advanced algorithms,neural networks, and deep
                          learning techniques to analyze audio input, identify spoken words, transcribe them into a
                          readable and usable format.</p>
                      </div>
                      <div class="content-details fadeIn-bottom">
                        <ul>
                          <li><i class="fa fa-check" role="presentation"></i> Transcription Services </li>
                          <li><i class="fa fa-check" role="presentation"></i> Voice Assistants </li>
                          <li><i class="fa fa-check" role="presentation"></i> Voice command systems</li>
                          <li><i class="fa fa-check" role="presentation"></i> Customer service chatbots </li>
                          <li><i class="fa fa-check" role="presentation"></i> Speech Analytics </li>
                          <li><i class="fa fa-check" role="presentation"></i> Accessibility for deaf people</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>



                <div class="col-lg-4 col-md-6 col-sm-12 cat--2 filter machine_learning Technology">
                  <div href="#" class="projects-wrap style-01 fading-image">
                    <div class="projects-image-box contents">
                      <div class="projects-image">
                        <img src="../../../assets/images/aiimages/topicmodelling.png" style="width:100%" alt="topicmodelling"
                          class="w-33.3" />
                        <div class="content">
                          <h2 class="heading"> Topic Modelling </h2>
                          <p style="margin-top: 25px">Gain insights from large volumes of texual data and automate
                            various aspects of text analysis and organization. </p>
                        </div>
                        <div class="content-details fadeIn-bottom" style="line-height: -6%">
                          <ul>
                            <li><i class="fa fa-check" role="presentation"></i> Content Recommendation </li>
                            <li><i class="fa fa-check" role="presentation"></i> Information retrieval </li>
                            <li><i class="fa fa-check" role="presentation"></i> Content Summarization</li>
                            <li><i class="fa fa-check" role="presentation"></i> Content Tagging </li>
                            <li><i class="fa fa-check" role="presentation"></i> Fraud Detection</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="container">

              <div class="usecases-second-blog">
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12 cat--2 filter machine_learning Technology">
                    <div href="#" class="projects-wrap style-01 fading-image">
                      <div class="projects-image-box contents">
                        <div class="projects-image">
                          <img src="../../../assets/images/aiimages/supplychain (1).png" style="width:100%" alt="supplychain"
                            class="w-33.3" />
                        </div>
                        <div class="content">
                          <h2 class="heading"> Supply Chain</h2>
                          <p> Predictive and perspective capabilities, allowing businesses to make data-driven
                            decisions,improve efficiency, reduce costs, and enhance overall supply chain performance.
                          </p>
                        </div>
                        <div class="content-details fadeIn-bottom">
                          <ul>
                            <li><i class="fa fa-check" role="presentation"></i> Demand Forecasting </li>
                            <li><i class="fa fa-check" role="presentation"></i> Inventory Optimization </li>
                            <li><i class="fa fa-check" role="presentation"></i> Quality control</li>
                            <li><i class="fa fa-check" role="presentation"></i> Ware House Automation </li>
                            <li><i class="fa fa-check" role="presentation"></i> Supplier Risk Management </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="col-lg-4 col-md-6 col-sm-12 cat--2 filter machine_learning Technology">
                    <div href="#" class="projects-wrap style-01 fading-image">
                      <div class="projects-image-box contents">
                        <div class="projects-image">
                          <img src="../../../assets/images/aiimages/sentimentanalysis.png" style="width:100%" alt="sentimentanalysis"
                            class="w-33.3" />
                        </div>
                        <div class="content">
                          <h2 class="heading"> Sentiment Analysis </h2>
                          <p> Determine and analyze the sentiment or emotional tone expressed in text data. It helps
                            business and organizations understand how people feel about a particular topi,
                            product,service
                            or brand.</p>
                        </div>
                        <div class="content-details fadeIn-bottom">
                          <ul>
                            <li><i class="fa fa-check" role="presentation"></i> Social Media Monitoring </li>
                            <li><i class="fa fa-check" role="presentation"></i> Customer feedback analysis </li>
                            <li><i class="fa fa-check" role="presentation"></i> Brand Reputation Management</li>
                            <li><i class="fa fa-check" role="presentation"></i> Market Research </li>
                            <li><i class="fa fa-check" role="presentation"></i> Employee Feedback </li>
                            <li><i class="fa fa-check" role="presentation"></i> Political Analysis</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="col-lg-4 col-md-6 col-sm-12 cat--2 filter machine_learning Technology">
                    <div href="#" class="projects-wrap style-01 fading-image">
                      <div class="projects-image-box contents">
                        <div class="projects-image">
                          <img src="../../../assets/images/aiimages/playerscore.png" style="width:100%" alt="playerscore"
                            class="w-33.3" />
                        </div>
                        <div class="content">
                          <h3 class="content_title"> Player Score & Match Prediction </h3>
                          <p style="line-height: 22px">Predecting Player score and match outcomes using AI/ML involves
                            developing models that analyse historical data, player statistics and various game related
                            factors to make predictions.</p>
                        </div>
                        <div class="content-details fadeIn-bottom">
                          <ul>
                            <li><i class="fa fa-check" role="presentation"></i> Sports Analytics </li>
                            <li><i class="fa fa-check" role="presentation"></i> Fantasy Sports </li>
                            <li><i class="fa fa-check" role="presentation"></i> Injury Prediction</li>
                            <li><i class="fa fa-check" role="presentation"></i> Game outcome prediction </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- =================== Use cases section ends =================== -->





  <!-- ================== Carousel section starts ================== -->



  <div class="row">
    <div class="casestudy-mainsection col-12 offset-sm-2 col-sm-8 aos-init aos-animate" data-aos="fade-up">
      <div class="casestudy_headder global_section_header my-3 mt-lg-5">
        <div class="h4 fw-bold">Client Success Stories</div>
      </div>
      <div class="Client-Success-Stories">
        <p>Learn how we’re helping our clients take the big move with technology and the difference they make
          across the globe.</p>
      </div>

    </div>
  </div>


  <div class="swiper-slide swiper-slide-active" data-swiper-slide-index="0">
  
    <div class="single-flexible-slider">
      <img src="../../../assets/images/aiimages/clientimg.png" alt="arrow" style="width:100%; height: 450px" />
      <div class="overlay-text_case-studies h-100 w-100 aos-init aos-animate" data-aos="fade-down">
        <div class="row mx-0 h-75">
          <div class="col-12 offset-md-1 col-md-8 col-lg-4 px-0 h-70">
            <div class="wealth">
              <div class="text-black">
                <h2 style="text-align: left">Wealth management institution sought swift PII solution using AI/ML</h2>
              </div>
              <a href="/pii-use-case-ai-ml" class="global_button">
                <div class="dub-arrow">
                  <img src="../../../assets/images/aiimages/arrowBlack.png"
                    alt="view all button" style="text-align: center">
                </div> READ CASE STUDY
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
   
  </div>



  <div>
    <div class="industry-button  case-study-button text-center pt-5" style="line-height: 1.6;margin-left: 40%">
      <a href="case-studies" class="global_button">
        <div class="dub-arrow">
          <img src="../../../assets/images/button/arrowBlack.png" alt="view all button">
        </div> VIEW ALL
      </a>
    </div>
  </div>
</div>
<!-- </div> -->
<!-- =================== Carousel section Ends ============ -->



<!-- ================== Insights section starts ============== -->

<div id="main-wrapper">

  <div class="site-wrapper-reveal">

    <div class="projects-wrapper section-space--pt_90 projects-masonary-wrapper" style="background-color: #F8F9FA">

      <div class="container">

        <div class="row">

            <div class="col-lg-12">

              <div class="section-title-wrap text-center section-space--mb_40">

                <div class="casestudies_heading text-black global_section_header" role="heading">

                  <b style="font-size: 30px">Insights</b></div>

                <p style="color:black">Discovering Trending Insights from experts across industries</p>

              </div>

            </div>

            <div class="col-lg-12" id="carousal-cards">

              <swiper-container #empSwiperContainer  class="testimonial-slider__container"
              slides-per-view="3"
              [autoplay]="{ delay: 3000 }"
              [pagination]="{ el: '.swiper-pagination', clickable: true }"
              [loop]="true"
              [breakpoints]="swiperBreakpoints"> 
                    <swiper-slide class="py-5 px-2" id="swiper-carousal">

                        <div class="carousel-slider wow move-up">

                            <div class=" cat--2 filter machine_learning Technology">

                              <div href="#" class="projects-wrap style-01">

                                <div class="projects-image-box">

                                  <div class="projects-image  projects_image">

                                    <img src="../../../assets/images/aiimages/AI-img.png" alt="arrow" class="w-100" />

                                  </div>

                                  <div class="content">

                                    <h4>AI for Ecommerce: Enhancing Customer Experiences

                                      & Business Success</h4>

                                    <div class="post-categories">Cloud Computing</div>

                                    <div class="text" style="line-height: 24.5px">Artificial Intelligence (AI) is proving to be a

                                      game-changer. From streamlining..

                                    </div>

                                    <div class="box-projects-arrow">

                                      <span class="button-text">

                                        <a class="blog_anchorviewmore" href="ai-solutions-for-e-commerce">View More </a>

                                      </span>

                                      <i class="fa fa-long-arrow-right" style="margin-left: 10px !important;"></i>

                                    </div>

                                  </div>

                                </div>

                              </div>

                            </div>

                        </div>

                    </swiper-slide>

                       



                    <swiper-slide  class="py-5 px-2" id="swiper-carousal">

                        <div class="carousel-slider wow move-up">

                                <div class=" filter machine_learning Technology">

                                  <div class="projects-wrap style-01">

                                    <div class="projects-image-box">

                                      <div class="projects-image projects_image">

                                        <img src="../../../assets/images/aiimages/insightsimg-1.JPG" alt="arrow" style="height:189px; width: 384px"/>

                                      </div>

                                      <div class="content content1" style="padding-bottom: 112px; font-size: 11px;">

                                        <h4>Personalisation and machine learning in marketing</h4><br>

                                        <div class="post-categories">Artificial Intelligence (AI/ML)</div>

                                        <div class="text">Technology is getting

                                          personalised. So surprisingly

                                          personalised that ..

                                        </div>

                                        <div class="box-projects-arrow">

                                          <span class="button-text"><a class="blog_anchorviewmore"

                                              href="personalize-and-machine-learning">View

                                              More</a></span>

                                          <i class="fa fa-long-arrow-right" style="margin-left: 10px !important;"></i>

                                        </div>

                                      </div>

                                    </div>

                                  </div>

                                </div>

                        </div>

                    </swiper-slide>



                    <swiper-slide  class="py-5 px-2" id="swiper-carousal">

                        <div class="carousel-slider wow move-up">

                          <div class="cat--2 filter machine_learning Technology">

                            <div href="#" class="projects-wrap style-01">

                              <div class="projects-image-box">

                                <div class="projects-image projects_image">

                                  <img src="../../../assets/images/aiimages/pii-banner1.png" alt="arrow" style="height:189px; width: 384px"/>

                                </div>

                                <div class="content content2">

                                  <h4>Client Story: Protecting Personal Identifiable Information (PII) using AI/ML</h4>

                                  <div class="post-categories">Artificial Intelligence</div>

                                  <div class="text">The financial services

                                    industry operates and deals with vast amount of ....

                                  </div>

                                  <div class="box-projects-arrow">

                                    <span class="button-text"><a class="blog_anchorviewmore" href="pii-use-case-ai-ml">View

                                        More</a></span>

                                    <i class="fa fa-long-arrow-right" style="margin-left: 10px !important;"></i>

                                  </div>

                                </div>

                              </div>

                            </div>

                          </div>

                         </div>

                    </swiper-slide>





  <!--                   
                      <swiper-slide class="py-5 px-2" id="swiper-carousal">

                        <div class="carousel-slider wow move-up">

                            <div class=" cat--2 filter machine_learning Technology">

                              <div href="#" class="projects-wrap style-01">

                                <div class="projects-image-box">

                                  <div class="projects-image  projects_image">

                                    <img src="../../../assets/images/aiimages/AI-img.png" alt="arrow" class="w-100" />

                                  </div>

                                  <div class="content">

                                    <h4>AI for Ecommerce: Enhancing Customer Experiences

                                      & Business Success</h4>

                                    <div class="post-categories">Cloud Computing</div>

                                    <div class="text" style="line-height: 24.5px">Artificial Intelligence (AI) is proving to be a

                                      game-changer. From streamlining..

                                    </div>

                                    <div class="box-projects-arrow">

                                      <span class="button-text">

                                        <a class="blog_anchorviewmore" href="ai-solutions-for-e-commerce">View More </a>

                                      </span>

                                      <i class="fa fa-long-arrow-right" style="margin-left: 10px !important;"></i>

                                    </div>

                                  </div>

                                </div>

                              </div>

                            </div>

                        </div>

                    </swiper-slide> -->

                <!-- </div>

                    <div class="swiper-pagination swiper-pagination-9 section-space--mt_50"></div> -->

              </swiper-container>

            </div>

          <!-- </div> -->

        </div>

      </div>

    </div>

  </div>

</div>

<!-- ================== Insights section ends ============== -->





<!-- =================== AI Services section starts  ============== -->
 <section><div class="strategysession">
  <div class="get row">
    <div class="col-md-6 Ai_Services">
      <div class="h4 fw-bold">Get a 30 minute, no cost strategy session with a Data and AI Services expert</div>
      <p style="color:black">Get started by talking to our experts about how to empower your organization with the right
        data foundation, modernization and platform management.</p>
        <div class="insight-button2 text-left py-3 py-md-5">
          <a href="contact" class="global_button">
              <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrowBlack" />
              </div>LET'S TALK
          </a>
      </div>
    </div>

    <div class="col-md-6">
      <div class="softwareimg">
        <img alt="softwareimg" src="../../../assets/images/aiimages/softwareimg.png" width="100%" />
      </div>
    </div>
  </div>
</div></section>

<!-- =================== AI Services section ends ============== -->